import React, { FC, FormEvent } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'esa-ui-library';
import { Form } from '..';
import { useStore } from '../../../common';

interface EmailFormProps {
	onSubmit: () => void;
	onForgot?: () => void;
	onBack?: () => void;
	isForgot?: boolean;
}

const EmailForm: FC<EmailFormProps> = ({ onSubmit, onForgot, onBack, isForgot: isForgotProp = false }): JSX.Element => {
	const [state, dispatch] = useStore(true);
	const { email: initialEmail, emailInvalid, two_step_code: initialTwoStepCode, errors, success } = state;

	const [email, setEmail] = React.useState(initialEmail);
	const [twoStepCode, setTwoStepCode] = React.useState(initialTwoStepCode || '');
	const [isForgot, setIsForgot] = React.useState(isForgotProp);

	React.useEffect(() => {
		setIsForgot(isForgotProp);
	}, [isForgotProp]);

	const onEmailChange = (val: string) => {
		setEmail(val);
		dispatch('EMAIL', val);
	};

	const onTwoStepCodeChange = (val: string) => {
		setTwoStepCode(val);
		dispatch('TWO_STEP_CODE', val);
	};

	const submitHandler = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		onSubmit();
	};

	const handleForgotClick = () => {
		if (onForgot) {
			onForgot();
		} else {
			setIsForgot(true);
		}
	};

	const handleBackClick = () => {
		if (onBack) {
			onBack();
		} else {
			setIsForgot(false);
		}
	};

	const isSubmitDisabled = !email || emailInvalid || (isForgot && !twoStepCode);

	return (
		<Form errors={errors} success={success}>
			<form onSubmit={submitHandler}>
				<Input
					type='text'
					label='Email'
					value={email}
					placeholder='Enter your email here'
					dataId='email-field'
					onChange={onEmailChange}
				/>
				{isForgot && (
					<Input
						type='number'
						label='Two step code'
						value={twoStepCode}
						placeholder='Enter your two step code here'
						dataId='two-step-code-field'
						onChange={onTwoStepCodeChange}
						name='two_step_code'
					/>
				)}
				<Button type='submit' title='Continue' fluid primary disabled={isSubmitDisabled} dataId='submit-button' />
				{!isForgot && (
					<Button
						type='button'
						title='Forgot password'
						fluid
						teritary
						dataId='forgot-button'
						onClick={handleForgotClick}
					/>
				)}
				{isForgot && (
					<Button type='button' title='Back to login' fluid teritary dataId='back-button' onClick={handleBackClick} />
				)}
			</form>
		</Form>
	);
};

EmailForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onForgot: PropTypes.func,
	onBack: PropTypes.func,
	isForgot: PropTypes.bool,
};

export { EmailForm };
